import type { ReactElement } from 'react'
import { Suspense, lazy } from 'react'

import { Navigate } from 'react-router-dom'
import { Loader } from '../components/Loader'
import { useIsMobile } from '../hooks/useIsMobile'
import { updatePlatformHeader } from '../services/api/auth'
import { setPlatformForLogs } from '../services/datadog'

const MobileSignInPage = lazy(() =>
  import('../pages/signin/mobile/SignInPage').then((module) => ({
    default: module.SignInPage,
  })),
)

export const SignInMobileRoute = (): ReactElement => {
  const platform = 'web'
  const isMobileScreen = useIsMobile()

  updatePlatformHeader(platform)
  setPlatformForLogs(platform)

  // Use conditional rendering to avoid hook violations
  return isMobileScreen ? (
    <Suspense fallback={<Loader />}>
      <MobileSignInPage />
    </Suspense>
  ) : (
    <Navigate to={'/signin'} replace />
  )
}
